/**
 * 쿠폰 다운로드 실패 문구 — 서버가 내려준 사유를 그대로 노출한다.
 *
 * `POST /api/v1/coupons/claim` 은 발급 불가 사유(기간 만료, 발급 수량 소진, 중복 발급 등)를
 * 백엔드 공통 에러 봉투(`{ errorCode, message }`) 의 `message` 로 내려준다.
 * 화면마다 사유를 다시 분기하지 않고 이 문구를 그대로 쓴다.
 *
 * 봉투가 없는 실패(네트워크 끊김 등)는 사용자에게 보여줄 문구가 아니므로 `fallback` 을 쓴다.
 */
export function getClaimCouponErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (typeof error !== 'object' || error === null) return fallback;

  const { message } = error as { message?: unknown };
  return typeof message === 'string' && message.trim() ? message : fallback;
}
